import { bindActionCreators } from 'redux';
import { NAMESPACE } from 'react/api/actions/base';

export const actions = {
  onSelect: `${NAMESPACE}_TAB_SELECT`,
  onClose: `${NAMESPACE}_TAB_CLOSE`,
  onExpand: `${NAMESPACE}_TAB_EXPAND`,
  onSort: `${NAMESPACE}_TAB_SORT`,
  onResize: `${NAMESPACE}_TAB_RESIZE`,
  updateTitle: `${NAMESPACE}_TAB_UPDATE_TITLE`,
  openPanelAtLogin: `${NAMESPACE}_TAB_LOAD_PANEL`,
  openHelp: `${NAMESPACE}_TAB_HELP`,
  openHelpAfterLogin: `${NAMESPACE}_TAB_HELP_AFTER_LOGIN`,
  openRouteSuggestion: `${NAMESPACE}_TAB_ROUTE_SUGGESTION`,
  setExtraArgs: `${NAMESPACE}_SET_EXTRA_ARGS`
};

export const actionCreators = {
  onSelect: (payload) => ({ type: actions.onSelect, payload }),
  onClose: (payload) => ({ type: actions.onClose, payload }),
  onExpand: (payload) => ({ type: actions.onExpand, payload }),
  onSort: (payload) => ({ type: actions.onSort, payload }),
  onResize: (payload) => ({ type: actions.onResize, payload }),
  openPanelAtLogin: (payload) => ({ type: actions.openPanelAtLogin, payload }),
  updateTitle: (payload) => ({ type: actions.updateTitle, payload }),
  setExtraArgs: (payload) => ({ type: actions.setExtraArgs, payload })
};

export const mapDispatchToProps = (dispatch) => (
  bindActionCreators(actionCreators, dispatch)
);

export default {
  actions,
  actionCreators,
  mapDispatchToProps
};
